import React from "react";
import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Project } from "../../../interfaces/Project";
import { ediphiPalette } from "../../styles/colors";

/** A project's city and state with a map pin, or null when the project has neither. */
export const formatLocation = (project: Project): JSX.Element | null => {
  const city = project.city || "";
  const state = project.state || "";

  if (!city && !state) {
    return null;
  }

  const locationText = city && state ? `${city}, ${state}` : city || state;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <LocationOnIcon sx={{ fontSize: "1rem", color: ediphiPalette.greyText }} />
      <Typography variant="body2" component="span">
        {locationText}
      </Typography>
    </Box>
  );
};
